import { Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { getConfig } from './config';
import Auth0ProviderWrapper from './modules/Manager/auth/auth0/Auth0ProviderWrapper';
import EntraIdProviderWrapper from './modules/Manager/auth/entraId/EntraIdProviderWrapper';
import KeycloakProviderWrapper from './modules/Manager/auth/keycloak/KeycloakProviderWrapper';
import OidcProviderWrapper from './modules/Manager/auth/oidc/OidcProviderWrapper';
import GitHubProviderWrapper from './modules/Manager/auth/github/GitHubProviderWrapper';
import GlobalAccountConflictProvider from './modules/Manager/Components/Common/GlobalAccountConflictProvider';
import { PageSkeleton } from './components/SkeletonLoaders';
import ErrorBoundary from './components/ErrorBoundary';
import lazyLoad from './utils/lazyLoad';

// Use lazyLoad utility for code splitting with prefetch
const AppRoutes = lazyLoad(() => import('./routes/AppRoutes'), { prefetch: true });

// Dynamically select the Auth Provider based on configuration
const AppAuthProvider = ({ children }) => {
  const config = getConfig();

  switch (config.authProvider) {
    case "entraId":
      return <EntraIdProviderWrapper>{children}</EntraIdProviderWrapper>;
    case "keycloak":
      return <KeycloakProviderWrapper>{children}</KeycloakProviderWrapper>;
    case "auth0":
      return <Auth0ProviderWrapper>{children}</Auth0ProviderWrapper>;
    case "oidc":
      return <OidcProviderWrapper>{children}</OidcProviderWrapper>;
    case "github":
      return <GitHubProviderWrapper>{children}</GitHubProviderWrapper>;
    default:
      throw new Error(`Unsupported auth provider: ${config.authProvider}`);
  }
};

function App() {
  return (
    <BrowserRouter>
      <AppAuthProvider>
        <GlobalAccountConflictProvider>
          <ErrorBoundary>
            <Suspense fallback={<PageSkeleton variant="simple" />}>
              <AppRoutes />
            </Suspense>
          </ErrorBoundary>
        </GlobalAccountConflictProvider>
        <ToastContainer />
      </AppAuthProvider>
    </BrowserRouter>
  );
}

export default App; 
